import { GridItem } from '@zuto/core/src/grid'
import React from 'react'
import PrefillDataOverview from '../PopulatedData/PrefillDataOverview'
import PrefillIntroductionV3 from '../Introductions/PrefillIntroduction/PrefillIntroductionV3/PrefillIntroductionV3'
import { PrefillOverviewProps } from './types'
import { LenderDetails } from './ApplicationFormContext'

type PrefillReviewPageWrapperProps = PrefillOverviewProps & {
  isReapply: boolean
  isReviewPageV3PreApproval: boolean
  lenderDetails?: LenderDetails
}

const PrefillReviewPageWrapper = ({
  prefillData,
  isReapply,
  isReviewPageV3PreApproval,
  lenderDetails
}: PrefillReviewPageWrapperProps): JSX.Element => (
  <GridItem data-testid="app-introduction" gridColumn={['auto / span 12', '3 / span 8']} pb={4}>
    <PrefillIntroductionV3
      prefillData={prefillData}
      isReapply={isReapply}
      isReviewPageV3PreApproval={isReviewPageV3PreApproval}
      lenderDetails={lenderDetails}
    />
    <PrefillDataOverview
      prefillData={prefillData}
    />
  </GridItem>
)

export default PrefillReviewPageWrapper
